import request from '@/utils/request'

let BASEROOT = '/visitor/v2'
let BASEROOTV3 = '/visitor/v3'
let BUSINESS_API_BASE = ''
let TRACKING_API_BASE = ''

// 业务中台生产地址
// if (process.env.NODE_ENV === 'production') {
//   BUSINESS_API_BASE = 'https://ef-biz-notice.eastfair.cn'
//   TRACKING_API_BASE = 'https://logserver.eastfair.cn'
// } else if (process.env.NODE_ENV === 'test') {
//   BUSINESS_API_BASE = 'http://masterpig-gateway.platform.test.eastfair.cn'
//   // TRACKING_API_BASE = 'http://masterlogserver.platform.test.eastfair.cn'
//   TRACKING_API_BASE = 'http://test-izt.klef.cn'
// }

BUSINESS_API_BASE = 'https://ef-biz-notice.eastfair.cn'
TRACKING_API_BASE = 'https://logserver.eastfair.cn'


let IdCardAuthon = 'https://std.eastfair.com/IdCardAuthon/api/IdentityCheck'

let ROOM_BASE = 'https://trtc.tencentcloudapi.com'

//身份证一致性
export function CheckValidation(data) {
  return request({
    url: IdCardAuthon + '/CheckValidationv2',
    method: 'post',
    data: data
  })
}

// 登录方法
export function login(param) {
  return request({
    url: BASEROOT + '/account/webLogon',
    method: 'post',
    data: param
  })
}

// 检测展商账号是否存在
export function checkBindExhibition(param) {
  return request({
    url: BASEROOT + '/account/checkBindExhibition',
    method: 'post',
    data: param
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}
//邮箱验证码
export function sendEmailCode(query) {
  return request({
    url: BASEROOT + '/account/getEmailCode',
    method: 'post',
    data: query
  })
}
//短信验证码
export function sendPhoneCode(query) {
  return request({
    url: BASEROOT + '/account/getSmsCode',
    method: 'post',
    data: query
  })
}

// 校验手机号是否重复

export function validateMobile(query) {
  return request({
    url: BASEROOT + '/account/validateMobile',
    method: 'post',
    data: query
  })
}

export function setPassWord(query) {
  //设置-找回密码
  return request({
    url: BASEROOT + '/account/setPassword',
    method: 'post',
    data: query
  })
}
export function changePassword(query) {
  //修改密码
  return request({
    url: BASEROOT + '/account/changePassword',
    method: 'post',
    data: query
  })
}
//绑定展商
export function bindExhibitorCode(query) {
  return request({
    url: BASEROOT + '/account/bindExhibitor',
    method: 'post',
    data: query
  })
}
// 手机号是否重复
export function checkPhone(query) {
  return request({
    url: BASEROOT + '/account/validateMobile',
    method: 'post',
    data: query
  })
}
// 邮箱是否重复
export function checkEmail(query) {
  return request({
    url: BASEROOT + '/account/validateEmail',
    method: 'post',
    data: query
  })
}
// 展商-完善、更新员工信息
export function updateStaffInfo(query) {
  return request({
    url: BASEROOT + '/account/completeUserInfo',
    method: 'post',
    data: query
  })
}

// 获取当前客商信息
export function getVisitor(query) {
  return request({
    url: BASEROOT + '/visitor/getVisitor',
    method: 'post',
    data: query
  })
}

// 获取当前客商往届信息
export function getPreviousVisitor(query) {
  return request({
    url: BASEROOT + '/visitor/getPreviousVisitor',
    method: 'post',
    data: query
  })
}

//完善客商信息
export function completeVisitor(query) {
  return request({
    url: BASEROOT + '/account/completeVisitor',
    method: 'post',
    data: query
  })
}

export function allocationCustomerService(data) {
  return request({
    url: BASEROOT + '/account/allocationCustomerService',
    method: 'post',
    data: data
  })
}

// 游客模式获取在线客服与游客IM
export function allocationCustomerServiceNew(data) {
  return request({
    url: BASEROOT + '/account/allocationCustomerServiceNew',
    method: 'post',
    data: data
  })
}

// 上传文件
export function uploadOssByStream(query, config) {
    return request({
        url: BUSINESS_API_BASE + '/uploadOssByStream',
        method: 'post',
        data: query,
        ...config
    })
}

// 上传图片，文件, 视频
export function uploadImageByBaseStr(query, config) {
  return request({
    url: BUSINESS_API_BASE + '/uploadImageByBaseStr',
    method: 'post',
    data: query,
    ...config
  })
}

// 上传图片多图片/视频
export function uploadMultipleImageByBaseStr(query, config) {
  return request({
    url: BUSINESS_API_BASE + '/uploadMultipleImageByBaseStr',
    method: 'post',
    data: query,
    ...config
  })
}

// 公司管理(读取展商信息)
export function getExhibitorBaseInfo(query) {
  return request({
    url: BASEROOT + '/exhibitor/getExhibitorBaseInfo/v1',
    method: 'post',
    data: query
  })
}
// 员工管理-编辑/添加
export function updateEmployee(query) {
  return request({
    url: BASEROOT + '/exhibitorEmployee/manager/update',
    method: 'post',
    data: query
  })
}
// 员工列表
export function getEmployeeList(query) {
  return request({
    url: BASEROOT + '/exhibitorEmployee/manager/list',
    method: 'post',
    data: query
  })
}

export function delEmployee(query) {
  return request({
    url: BASEROOT + '/exhibitorEmployee/manager/resigned',
    method: 'post',
    data: query
  })
}

// 添加/修改 展品
export function updateExhibit(query) {
  return request({
    url: BASEROOT + '/product/insertProduct',
    method: 'post',
    data: query
  })
}

// 获取产品标签
export function getProductTags(query) {
  return request({
    url: BASEROOT + '/customQuestions/questionSite',
    method: 'post',
    data: query
  })
}
// 获取产品列表
export function getProducts(query) {
  return request({
    url: BASEROOT + '/product/productList',
    method: 'post',
    data: query
  })
}
// 客商-账号信息/v2/account/completeVisitor
export function addVisitor(data){
  return request({
    url: BASEROOT + '/account/addVisitor',
    method: 'post',
    data: data
  })
}
//获取展品详情
export function getProductDetail(data) {
  return request({
    url: BASEROOT + '/productRecommend/visitor/recommendProductDetails',
    method: 'post',
    data: data
  })
}

// 删除展品
export function deleteProduct(query) {
  return request({
    url: BASEROOT + '/product/deleteProduct',
    method: 'post',
    data: query
  })
}

// 获取公司管理编辑的字段
export function getFetchList(data) {
  return request({
    url: BASEROOT + '/configurationItem/visitor/getConfigurationInformation',
    method: 'post',
    data: data
  })
}

// 获取公司管理编辑的字段
export function updateExhibitorInfo(data) {
  return request({
    url: BASEROOT + '/exhibitor/updateExhibitorBaseInfo/v1',
    method: 'post',
    data: data
  })
}

// 获取国家
export function fetchCountry(data) {
  return request({
    url: BASEROOT + '/area/getCountryList',
    method: 'get',
    params: data
  })
}

/**
 * 获取省份
 * @param {*} data
 * countryId: 国家id
 */
export function fetchProvince(data) {
  return request({
    url: BASEROOT + '/area/getProvinceList',
    method: 'get',
    params: data
  })
}

/**
 * 获取城市
 * @param {Object} data
 * provinceId: 省份id
 */
export function fetchCity(data) {
  return request({
    url: BASEROOT + '/area/getCityList',
    method: 'get',
    params: data
  })
}

// 添加收藏
export function addCollection(data) {
  return request({
    url: BASEROOT + '/collection/addCollection',
    method: 'post',
    data: data
  })
}

// 取消收藏
export function updateCollection(data) {
  return request({
    url: BASEROOT + '/collection/update',
    method: 'post',
    data: data
  })
}

// 邀约
export function addInviteRecrd(data) {
  return request({
    url: BASEROOT + '/inviteRecord/newAddInviteRecrd',
    method: 'post',
    data: data
  })
}

// 全部邀约
export function newContactPersonList(data) {
  return request({
    url: BASEROOT + '/contactPerson/newContactPersonList',
    method: 'post',
    data: data
  })
}

// 待确认
export function inviteRecordList(data) {
  return request({
    url: BASEROOT + '/inviteRecord/inviteRecordList',
    method: 'post',
    data: data
  })
}

// 展商邀约 待确认
export function exhInviteRecordList(data) {
  return request({
    url: BASEROOT + '/PcInviteRecord/inviteRecordList',
    method: 'post',
    data: data
  })
}

// 展商邀约 全部
export function exhContactPersonList(data) {
  return request({
    url: BASEROOT + '/PcContactPerson/contactPersonList',
    method: 'post',
    data: data
  })
}


// 邀约确认
export function confirmInviteRecord(data) {
  return request({
    url: BASEROOT + '/inviteRecord/newConfirmInviteRecord',
    method: 'post',
    data: data
  })
}

// 客商获取展商员工列表
export function getExhibitorEmployeeList(data) {
  return request({
    url: BASEROOT + '/exhibitorEmployee/visitor/getExhibitorEmployeeList',
    method: 'post',
    data: data
  })
}

// 获取展会配置
export function getAppVersion(data) {
  return request({
    url: BASEROOT + '/versionInfo/getAppVersion',
    method: 'post',
    data: data
  })
}

// 新闻详情
export function getArticle(data) {
  return request({
    url: BASEROOT + '/article/getArticle',
    method: 'post',
    data: data
  })
}

// 新闻
export function getArticleList(data) {
  return request({
    url: BASEROOT + '/article/getArticleListPc',
    method: 'post',
    data: data
  })
}
// 获取问卷
export function loadQuestion(data){
  return request({
    url: BASEROOT + '/questions/questionnaire',
    method: 'post',
    data: data
  })
}
// 保存问卷
export function saveQuestion(data){
  return request({
    url: BASEROOT + '/questions/saveQuestion',
    method: 'post',
    data: data
  })
}

// 判断用户是否审核通过
export function getVisitorAuditState(data) {
  return request({
    url: BASEROOT + "/visitor/getVisitorAuditState",
    method: 'post',
    data: data
  })
}

// 展商工作台导出客户意向
// export function queryProductCollection(data){
//   return request({
//     url: BASEROOT + '/collection/queryProductCollection',
//     method: 'post',
//     data: data
//   })
// }


// 通知列表
export function noticeListType(data){
  return request({
    url: BASEROOT + '/notice/listType',
    method: 'post',
    data: data
  })
}

// 通知详情
export function noticeList(data){
  return request({
    url: BASEROOT + '/notice/list',
    method: 'post',
    data: data
  })
}

// 查看通知详情

export function noticeGetNotice(data){
  return request({
    url: BASEROOT + '/notice/getNotice',
    method: 'post',
    data: data
  })
}

// 添加新联系人到会话列表
export function saveContact(data) {
  return request({
    url: BASEROOT + '/imRecord/addImRecord',
    method: 'post',
    data: data
  })
}

// 获取会话列表
export function getContacts(data) {
  return request({
    url: BASEROOT + '/imRecord/list',
    method: 'post',
    data: data
  })
}
// 获得邮箱验证码(滑动)

export function getLimitVerificationToken(data) {
  return request({
    url: BASEROOT + '/account/getLimitVerificationToken',
    method: 'post',
    data: data
  })
}

// 邮箱注册帐号2020.08.18

export function registerUserByEmail(data) {
  return request({
    url: BASEROOT + '/account/registerUserByEmail',
    method: 'post',
    data: data
  })
}

// pc邮箱注册帐号，无验证，滑动验证

export function registerUserByEmailNotCheck(data) {
  return request({
    url: BASEROOT + '/account/registerUserByEmailNotCheck',
    method: 'post',
    data: data
  })
}

// 人脸试别

export function getFaceIdentify(data) {
  return request({
    url: BASEROOT + '/userInfo/getFaceIdentify',
    method: 'post',
    data: data
  })
}

// 根据token设置密码2020.08.18
export function setPasswordByToken(data) {
  return request({
    url: BASEROOT + '/account/setPasswordByToken',
    method: 'post',
    data: data
  })
}

// 批量修改展品的可见范围（保利）
export function batchUpdateScope(data) {
  return request({
    url: BASEROOT + '/product/batchUpdateScope',
    method: 'post',
    data: data
  })
}

// 修改全部展品的可见范围(baoli)
export function batchUpdateScopeAll(data) {
  return request({
    url: BASEROOT + '/product/batchUpdateScopeAll',
    method: 'post',
    data: data
  })
}
// 批量删除展品(baoli)
export function batchDelete(data) {
  return request({
    url: BASEROOT + '/product/batchDelete',
    method: 'post',
    data: data
  })
}
// 删除全部的展品(baoli)
export function batchDeleteAll(data) {
  return request({
    url: BASEROOT + '/product/batchDeleteAll',
    method: 'post',
    data: data
  })
}

// 埋点
export function webTracking(data) {
  return request({
    url: TRACKING_API_BASE + '/burying',
    method: 'post',
    data: data
  })
}


//删除客户池
export function deleteContactPerson(data) {
  return request({
    url: BASEROOT + '/contactPerson/deleteContactPerson',
    method: 'post',
    data: data
  })
}

// 创建锚点图片
export function createHotspotImage(data) {
  return request({
    url: BASEROOT + '/hotImage/insert',
    method: 'post',
    data: data
  })
}

// 重新分配员工
export function distributionEmployee(data) {
  return request({
    url: BASEROOT + '/contactPerson/distributionEmployee',
    method: 'post',
    data: data
  })
}

// 创建/跟新 -锚点
export function setHotspots(data) {
  return request({
    url: BASEROOT + '/hotImagePoint/insertList',
    method: 'post',
    data: data
  })
}

// 获取客户池数量
export function getContactPersonNum(data) {
  return request({
    url: BASEROOT + '/PcContactPerson/getNum',
    method: 'post',
    data: data
  })
}

// 修改锚点图片
export function updateHotspotImage(data) {
  return request({
    url: BASEROOT + '/hotImage/update',
    method: 'post',
    data: data
  })
}

// 获取锚点信息
export function getHotspotDetail(data) {
  return request({
    url: BASEROOT + '/hotImage/get',
    method: 'post',
    data: data
  })
}

// 热点图列表
export function getHotImageList(data) {
  return request({
    url: BASEROOT + '/hotImage/listByExhibitor',
    method: 'post',
    data: data
  })
}

// 删除热点图
export function deleteHotImage(data) {
  return request({
    url: BASEROOT + '/hotImage/delete',
    method: 'post',
    data: data
  })
}

// 首页热点图
export function homeHotspotImage(data) {
  return request({
    url: BASEROOT + '/hotImage/recommendList',
    method: 'post',
    data: data
  })
}

// 获取聊天用户信息
export function getUserInfoByEasemob(data) {
  return request({
    url: BASEROOT + '/userInfo/getUserInfoByEasemob',
    method: 'post',
    data: data
  })
}

// 获取展商的直播时长配置

export function queryExhibitorConfig(query){
  return request({
      url: BASEROOT + '/liveMag/queryExhibitorConfig',
      method: 'post',
      data: query
  })
}

// 通过邀请码添加客户池
export function addContactPersonByInviteCode(query){
  return request({
      url: BASEROOT + '/contactPerson/addContactPersonByInviteCode',
      method: 'post',
      data: query
  })
}

// 展商查看邀请码
export function getInviteCode(query){
  return request({
      url: BASEROOT + '/exhibitorEmployee/getInviteCode',
      method: 'post',
      data: query
  })
}

// 展商导出邀约已确认
export function exportContactPerson(query){
  return request({
      url: BASEROOT + '/PcContactPerson/exportContactPerson',
      method: 'post',
      data: query
  })
}

// 展商导出邀约待确认
export function exportInviteRecord(query){
  return request({
      url: BASEROOT + '/PcContactPerson/exportInviteRecord',
      method: 'post',
      data: query
  })
}

// 客商导出展品收藏
export function exportExcelProduct(query){
  return request({
      url: BASEROOT + '/collection/exportExcelProduct',
      method: 'post',
      data: query
  })
}

// 客商导出展商收藏
export function exportExcelActor(query){
  return request({
      url: BASEROOT + '/collection/exportExcelActor',
      method: 'post',
      data: query
  })
}



// 验证Token获取接口
export function GetValidationToken(data) {
  return request({
    url: IdCardAuthon + '/GetValidationToken',
    method: 'post',
    data: data
  })
}

// vip 申请信息提交
export function vipInsert(query){
  return request({
      url: BASEROOT + '/vip/insert',
      method: 'post',
      data: query
  })
}

// vip 申请信息获取
export function vipInfo(query){
  return request({
      url: BASEROOT + '/vip/get',
      method: 'post',
      data: query
  })
}

// 上传Excel获取邮箱列表
export function importEmail(query) {
    return request({
        url: BASEROOT + '/invitation/importEmail',
        method: 'post',
        data: query
    })
}

//批量发送邀请函
export function sendEmail(query) {
    return request({
        url: BASEROOT + '/invitation/sendEmail',
        method: 'post',
        data: query
    })
}

//复制邀请函链接
export function saveEmail(query) {
    return request({
        url: BASEROOT + '/invitation/saveEmail',
        method: 'post',
        data: query
    })
}

// 展商发送邀请函时把发送记录推送到i展通
export function addRecord(query) {
    return request({
        url: BASEROOT + '/externalInterface/invitation/addRecord',
        method: 'post',
        data: query
    })
}

// 埋点
export function stopRoom(data) {
  return request({
    url: ROOM_BASE + '/',
    method: 'get',
    params: data
  })
}


// 获取游客userID 【IM模块】
export function getUserSigTourist(data) {
  return request({
    url: BASEROOT + '/live/getUserSigTourist',
    method: 'post',
    data: data
  })
}


// 通过token获取用户信息
export async function getUserInfo(query) {
  return await request({
    url: BASEROOT + '/userInfo/getUserInfoByToken',
    method: 'post',
    data: query
  })
}


// 获取会议列表
export async function querySourcingPage(query) {
  return await request({
    url: BASEROOT + '/sourcing/querySourcingPage',
    method: 'post',
    data: query
  })
}


// 获取我的展品列表
export async function productListWithoutQuestionnaire(query) {
  return await request({
    url: BASEROOT + '/product/productListWithoutQuestionnaire',
    method: 'post',
    data: query
  })
}

// 提交观众对接会表单提交
export async function saveVisitorNeeds(query) {
  return await request({
    url: BASEROOT + '/sourcing/saveVisitorNeeds',
    method: 'post',
    data: query
  })
}

// 提交展商对接会表单提交
export async function saveExhibitorSign(query) {
  return await request({
    url: BASEROOT + '/sourcing/saveExhibitorSign',
    method: 'post',
    data: query
  })
}


// 观众查询自己提交的表单
export function queryVisitorPage(query) {
    return request({
        url: BASEROOT + '/sourcing/queryVisitorPage',
        method: 'post',
        data: query
    })
}

// 观众查询需求表单详情
export function queryVisitorDetail(query) {
    return request({
        url: BASEROOT + '/sourcing/queryVisitorDetail',
        method: 'post',
        data: query
    })
}

// 观众删除自己提交的表单
export function deleteVisitorNeeds(query) {
    return request({
        url: BASEROOT + '/sourcing/deleteVisitorNeeds',
        method: 'post',
        data: query
    })
}

// 展商查看自己提交的报名记录
export function queryExhibitorSignPage(query) {
    return request({
        url: BASEROOT + '/sourcing/queryExhibitorSignPage',
        method: 'post',
        data: query
    })
}

// 查询展商报名详情
export function getExhibitorSignDetail(query) {
    return request({
        url: BASEROOT + '/sourcing/getExhibitorSignDetail',
        method: 'post',
        data: query
    })
}

// 获取展品
export async function getProductTagsList(query) {
    return await request({
        url: BASEROOT + '/product/productListWithoutQuestionnaire',
        method: 'post',
        data: query
    })
}

export async function updateProcurementDocking(query) {
    return await request({
        url: BASEROOT + '/sourcing/updateExhibitorSign',
        method: 'post',
        data: query
    })
}

// 获取短token
export function getAuthCode() {
  return request({
      url: BASEROOT + '/authLogin/getAuthCode',
      method: 'get'
  })
}

// 留言
export async function addSuggest(query) {
    return await request({
        url: BASEROOT + '/suggest/addSuggest',
        method: 'post',
        data: query
    })
}

// 活动列表
export async function activityQueryList(query) {
    return await request({
        url: BASEROOT + '/activity/queryList/v2',
        method: 'post',
        data: query
    })
}
// 活动详情
export async function activityQueryDetail(query) {
    return await request({
        url: BASEROOT + '/activity/queryDetail/v2',
        method: 'post',
        data: query
    })
}

// 获取板块管理
export async function listByProjectId(query) {
    return await request({
        url: BASEROOTV3 + '/pageConfig/listByProjectId',
        method: 'post',
        data: query
    })
}
